import { useCallback } from 'react';

import { AxiosResponse } from 'axios';
import { useInfiniteQuery, UseInfiniteQueryResult } from 'react-query';
import { UrlParams, PaginatedWorkoutMovementListList } from 'types';
import { client } from 'utils/api-client';
import { encodeUrlParams, urlParamsFromUrl } from 'utils/functions';

interface QueryKeyType {
  pageParam?: UrlParams;
}

interface IUseWorkoutBenchmarks {
  ordering?: string;
  search?: string;
  source?: string | null;
  limit?: string;
}

function useWorkoutBenchmarks({
  ordering,
  search,
  source,
  limit = '20',
}: IUseWorkoutBenchmarks): UseInfiniteQueryResult<AxiosResponse<PaginatedWorkoutMovementListList>> {
  const fetchWorkoutBenchmarks = useCallback(
    ({
      pageParam = { limit, offset: '0' },
    }: QueryKeyType): Promise<AxiosResponse<PaginatedWorkoutMovementListList>> => {
      const params = { ...pageParam };
      params.movement_type = 'benchmark';
      if (ordering) {
        params.ordering = ordering.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`).concat(',pk');
      }
      if (search) {
        params.search = search;
      }
      if (source) {
        params.source = source;
      }
      return client.get(`workout-movements/?${encodeUrlParams(params)}`);
    },
    [limit, ordering, search, source],
  );

  return useInfiniteQuery(['workoutBenchmarks', ordering, search, source], fetchWorkoutBenchmarks, {
    getNextPageParam: page => {
      return page.data.next ? urlParamsFromUrl(page.data.next) : undefined;
    },
  });
}

export default useWorkoutBenchmarks;
